import {
  baseRequestWithAxiosResponse,
  baseRequestWithHeaders,
} from './base-request';

export const getNetworkVaccination = (centerId) => {
  const url = `network-center/get-vaccination-centers-details?centerId=${centerId}`;
  const method = 'GET';
  return baseRequestWithHeaders(url, method, null);
};

export const getFeaturedNetworkCenters = () => {
  const url = `network-center/get-featured-network-centers`;
  const method = 'GET';
  return baseRequestWithHeaders(url, method, null);
};

export const updateFeaturedNetworkCenter = (body) => {
  const url = `network-center/update-featured-network-centers`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, body);
};

export const updateFeaturedNetworkCentersPriority = (body) => {
  const url = `network-center/update-featured-nc-prioirty`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, body);
};

export const searchCategories = (search) => {
  const url = `network-center/getCategory?search=${search}`;
  const method = 'GET';
  return baseRequestWithHeaders(url, method, null);
};

export const searchVaccines = (search, categoryId) => {
  const url = `network-center/getSubCategory?search=${search}&categoryId=${categoryId}`;
  const method = 'GET';
  return baseRequestWithHeaders(url, method, null);
};

export const updateVaccinationDetails = (body) => {
  const url = `network-center/updateVaccinationNetwork`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, body);
};

export const addVaccination = (body) => {
  console.log(body, '[body]');
  const url = `network-center/addNewVaccineForCenter`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, body);
};

export const addNewVaccine = (body) => {
  console.log(body, '[body]');
  const url = `network-center/addNewVaccine`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, body);
};

export const getAllVaccineData = (params = {}) => {
  const url = `network-center/sponsors-vaccinations`;
  const method = 'GET';
  return baseRequestWithHeaders(url, method, params, null);
};

export const getSponsorsForVaccine = (vaccineSubCategoryId) => {
  const url = `/network-center/getSponsor/${vaccineSubCategoryId}`;
  const method = 'GET';
  return baseRequestWithHeaders(url, method, null);
};

export const getAllSponsor = () => {
  const url = '/network-center/get-all-sponsor';
  const method = 'GET';
  return baseRequestWithHeaders(url, method, null);
};

export const updateSponsorForVaccine = (
  sponsorIds,
  vaccinationSubCategoryId
) => {
  console.log(
    { sponsorIds, vaccinationSubCategoryId },
    '[updateSponsorForVaccine]'
  );

  const url = `/network-center/update-sponsor`;
  const method = 'POST';
  const body = {
    vaccinationSubCategoryId: vaccinationSubCategoryId,
    sponsorIds: sponsorIds,
  };
  return baseRequestWithHeaders(url, method, null, body);
};
export const addNewVaccineCategory = (body) => {
  const url = `network-center/addVaccineCategory`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, body);
};

export const birthCriteria = () => {
  const url = `network-center/vaccintion-age-limit`;
  const method = 'GET';
  return baseRequestWithHeaders(url, method, null);
};

export const getPartners = () => {
  const url = `network-center/get-partners`;
  const method = 'GET';
  return baseRequestWithHeaders(url, method, null);
};

export const addPartner = (body) => {
  const url = `network-center/add-partner`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, body);
};
